import React from "react";

import { ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";

import StyledTooltip from "../../Common/UIComponents/StyledTooltip";

export default function CreateSamplingEventModalFooter({
  tabs,
  selectedTab,
  onCancel,
  onSubmit,
  onTabChange,
  disableNext,
  disableAddToCalendar,
  isSubmitLoading,
}) {
  /**
   * Handles Previous button click
   * @param {Number} currentTabIndex current tab index
   */
  const handlePreviousTabChange = (currentTabIndex) => {
    const previousTabIndex = currentTabIndex - 1;
    if (previousTabIndex >= 0) {
      onTabChange(tabs[previousTabIndex]);
    }
  };

  /**
   * Handle Next button click
   * @param {Number} currentTabIndex current tab index
   */
  const handleNextTabChange = (currentTabIndex) => {
    const nextTabIndex = currentTabIndex + 1;
    if (nextTabIndex < tabs.length) {
      onTabChange(tabs[nextTabIndex]);
    }
  };

  if (tabs && tabs.length > 0 && selectedTab) {
    const currentTabIndex = tabs.indexOf(selectedTab);
    const isFirstTab = currentTabIndex === 0;
    const isLastTab = tabs.length - 1 === currentTabIndex;
    return (
      <div className="CreateSamplingEventModal__Footer">
        <Button
          type="default"
          onClick={isFirstTab ? () => onCancel() : () => handlePreviousTabChange(currentTabIndex)}
          disabled={isLastTab && isSubmitLoading}
        >
          {isFirstTab ? "Cancel" : "Previous"}
        </Button>
        <StyledTooltip title={disableNext.status ? disableNext.reason : ""}>
          <Button
            type="primary"
            onClick={isLastTab ? () => onSubmit() : () => handleNextTabChange(currentTabIndex)}
            disabled={disableNext.status || isSubmitLoading}
            loading={isLastTab && isSubmitLoading}
            icon={isLastTab ? null : <ArrowRightOutlined />}
            iconPosition="end"
          >
            {isLastTab ? "Submit" : "Next"}
          </Button>
        </StyledTooltip>
      </div>
    );
  }

  return (
    <div className="CreateSamplingEventModal__Footer">
      <Button
        type="default"
        onClick={onCancel}
        disabled={isSubmitLoading}
      >
        Cancel
      </Button>
      <Button
        type="primary"
        onClick={onSubmit}
        disabled={disableAddToCalendar || isSubmitLoading}
        loading={isSubmitLoading}
      >
        Add to Calendar
      </Button>
    </div>
  );
}
